<template>
  <div>
    <b-card-title class="mb-2">
      {{ $t('settings.coordinates.etm.title') }}
    </b-card-title>
    <b-card-text class="mb-3 text-muted">
      {{ $t('settings.coordinates.etm.description') }}
    </b-card-text>

    <b-form @submit.prevent="handleSubmit">
      <b-row>
        <!-- Central Meridian -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.etm.central_meridian')"
            label-for="etm-central-meridian"
            :description="$t('settings.coordinates.etm.central_meridian_desc')"
          >
            <b-form-input
              id="etm-central-meridian"
              v-model.number="form.central_meridian"
              type="number"
              step="0.000001"
              required
            />
          </b-form-group>
        </b-col>

        <!-- Latitude of Origin -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.etm.latitude_of_origin')"
            label-for="etm-latitude-origin"
            :description="$t('settings.coordinates.etm.latitude_of_origin_desc')"
          >
            <b-form-input
              id="etm-latitude-origin"
              v-model.number="form.latitude_of_origin"
              type="number"
              step="0.000001"
              required
            />
          </b-form-group>
        </b-col>

        <!-- False Easting -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.etm.false_easting')"
            label-for="etm-false-easting"
            :description="$t('settings.coordinates.etm.false_easting_desc')"
          >
            <b-form-input
              id="etm-false-easting"
              v-model.number="form.false_easting"
              type="number"
              step="0.01"
              required
            />
          </b-form-group>
        </b-col>

        <!-- False Northing -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.etm.false_northing')"
            label-for="etm-false-northing"
            :description="$t('settings.coordinates.etm.false_northing_desc')"
          >
            <b-form-input
              id="etm-false-northing"
              v-model.number="form.false_northing"
              type="number"
              step="0.01"
              required
            />
          </b-form-group>
        </b-col>

        <!-- Scale Factor -->
        <b-col
          cols="12"
          md="6"
        >
          <b-form-group
            :label="$t('settings.coordinates.etm.scale_factor')"
            label-for="etm-scale-factor"
            :description="$t('settings.coordinates.etm.scale_factor_desc')"
          >
            <b-form-input
              id="etm-scale-factor"
              v-model.number="form.scale_factor"
              type="number"
              step="0.000001"
              required
            />
          </b-form-group>
        </b-col>
      </b-row>

      <!-- Actions -->
      <div class="d-flex justify-content-end mt-2">
        <b-button
          variant="outline-secondary"
          class="mr-1"
          :disabled="loading"
          @click="resetForm"
        >
          {{ $t('common.reset') }}
        </b-button>
        <b-button
          variant="primary"
          type="submit"
          :disabled="loading"
        >
          <b-spinner
            v-if="loading"
            small
            class="mr-50"
          />
          {{ $t('common.save') }}
        </b-button>
      </div>
    </b-form>
  </div>
</template>

<script>
import {
  BCardTitle,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BRow,
  BCol,
  BButton,
  BSpinner,
} from 'bootstrap-vue'

export default {
  name: 'EtmSettingsForm',
  components: {
    BCardTitle,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BButton,
    BSpinner,
  },
  props: {
    settings: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      form: {
        central_meridian: 31,
        latitude_of_origin: 30,
        false_easting: 615000,
        false_northing: 810000,
        scale_factor: 1.0,
      },
    }
  },
  watch: {
    settings: {
      immediate: true,
      deep: true,
      handler(newSettings) {
        if (newSettings && Object.keys(newSettings).length > 0) {
          this.form = { ...this.form, ...newSettings }
        }
      },
    },
  },
  methods: {
    handleSubmit() {
      this.$emit('save', { ...this.form })
    },
    resetForm() {
      if (this.settings && Object.keys(this.settings).length > 0) {
        this.form = { ...this.settings }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.mr-50 {
  margin-right: 0.5rem;
}
</style>
